// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   Detallsagenda — formulari de detall (Nou / Consultar / Modificar)
   Reforça la distinció visual entre Avís (taronja) i Tasca (blau) i
   millora la llegibilitat general del formulari.
   ============================================================ */

.Agenda-form {
  --agenda-accent: #FF9933;
}

.Agenda-form.Agenda-tema-tasca {
  --agenda-accent: #0099CC;
}

/* Accent de color a les seccions d'informació (mode consulta) */
.Agenda-form .dv2-card {
  border-left: 4px solid var(--agenda-accent);
}

.Agenda-form .info-inline {
  margin: 4px 0;
}

.Agenda-form .dv2-input.is-placeholder,
.Agenda-form .dv2-textarea.is-placeholder {
  color: #888;
  font-style: italic;
}

.Agenda-form .dv2-input.is-readonly {
  background: var(--dv2-bg, #f4f4f4);
  color: var(--dv2-text-muted, #666);
}

.Agenda-form .Agenda-tipus-toggle {
  padding-top: 4px;
}

.Agenda-form-row-capcalera {
  align-items: center;
}

.Agenda-tipus-toggle {
  display: inline-flex;
  gap: 6px;
  align-items: center;
}

.Agenda-tipus-toggle button.Agenda-badge {
  cursor: pointer;
  border: 2px solid transparent;
  padding: 2px 12px;
  font-size: 12px;
}

.Agenda-tipus-toggle button.Agenda-badge.Agenda-badge-inactiu {
  background-color: #fff;
  color: #666;
}

.Agenda-tipus-toggle button.Agenda-badge.Agenda-badge-inactiu.Agenda-badge-avis {
  border-color: #FF9933;
  color: #c46a10;
}

.Agenda-tipus-toggle button.Agenda-badge.Agenda-badge-inactiu.Agenda-badge-tasca {
  border-color: #0099CC;
  color: #007399;
}

.Agenda-tipus-toggle button.Agenda-badge:disabled {
  cursor: default;
  opacity: 0.85;
}

/* Badge de Tipus (definit també a seleccionaragenda.css, es reutilitza aquí) */
.Agenda-badge {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.6;
  white-space: nowrap;
  color: #fff;
}

.Agenda-badge-avis {
  background-color: #FF9933;
}

.Agenda-badge-tasca {
  background-color: #0099CC;
}

/* Enllaç per obrir/tancar seccions opcionals (p.ex. "Relacionar amb...") */
.Agenda-link-toggle {
  background: none;
  border: 1px dashed #bbb;
  border-radius: 4px;
  color: #0078d7;
  cursor: pointer;
  padding: 6px 12px;
  font-size: 13px;
}

.Agenda-link-toggle:hover {
  background-color: #f4f9ff;
  border-color: #0078d7;
}

/* Petit toc visual per separar blocs dins del formulari editable */
.Agenda-form .Dashboard-form-row {
  padding-bottom: 4px;
}

.Agenda-form .checkbox-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: normal;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/detallsagenda.css"],"names":[],"mappings":"AAAA;;;;iEAIiE;;AAEjE;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,gEAAgE;AAChE;EACE,2CAA2C;AAC7C;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA,+EAA+E;AAC/E;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2EAA2E;AAC3E;EACE,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,mEAAmE;AACnE;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB","sourcesContent":["/* ============================================================\r\n   Detallsagenda — formulari de detall (Nou / Consultar / Modificar)\r\n   Reforça la distinció visual entre Avís (taronja) i Tasca (blau) i\r\n   millora la llegibilitat general del formulari.\r\n   ============================================================ */\r\n\r\n.Agenda-form {\r\n  --agenda-accent: #FF9933;\r\n}\r\n\r\n.Agenda-form.Agenda-tema-tasca {\r\n  --agenda-accent: #0099CC;\r\n}\r\n\r\n/* Accent de color a les seccions d'informació (mode consulta) */\r\n.Agenda-form .dv2-card {\r\n  border-left: 4px solid var(--agenda-accent);\r\n}\r\n\r\n.Agenda-form .info-inline {\r\n  margin: 4px 0;\r\n}\r\n\r\n.Agenda-form .dv2-input.is-placeholder,\r\n.Agenda-form .dv2-textarea.is-placeholder {\r\n  color: #888;\r\n  font-style: italic;\r\n}\r\n\r\n.Agenda-form .dv2-input.is-readonly {\r\n  background: var(--dv2-bg, #f4f4f4);\r\n  color: var(--dv2-text-muted, #666);\r\n}\r\n\r\n.Agenda-form .Agenda-tipus-toggle {\r\n  padding-top: 4px;\r\n}\r\n\r\n.Agenda-form-row-capcalera {\r\n  align-items: center;\r\n}\r\n\r\n.Agenda-tipus-toggle {\r\n  display: inline-flex;\r\n  gap: 6px;\r\n  align-items: center;\r\n}\r\n\r\n.Agenda-tipus-toggle button.Agenda-badge {\r\n  cursor: pointer;\r\n  border: 2px solid transparent;\r\n  padding: 2px 12px;\r\n  font-size: 12px;\r\n}\r\n\r\n.Agenda-tipus-toggle button.Agenda-badge.Agenda-badge-inactiu {\r\n  background-color: #fff;\r\n  color: #666;\r\n}\r\n\r\n.Agenda-tipus-toggle button.Agenda-badge.Agenda-badge-inactiu.Agenda-badge-avis {\r\n  border-color: #FF9933;\r\n  color: #c46a10;\r\n}\r\n\r\n.Agenda-tipus-toggle button.Agenda-badge.Agenda-badge-inactiu.Agenda-badge-tasca {\r\n  border-color: #0099CC;\r\n  color: #007399;\r\n}\r\n\r\n.Agenda-tipus-toggle button.Agenda-badge:disabled {\r\n  cursor: default;\r\n  opacity: 0.85;\r\n}\r\n\r\n/* Badge de Tipus (definit també a seleccionaragenda.css, es reutilitza aquí) */\r\n.Agenda-badge {\r\n  display: inline-block;\r\n  padding: 2px 10px;\r\n  border-radius: 12px;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  line-height: 1.6;\r\n  white-space: nowrap;\r\n  color: #fff;\r\n}\r\n\r\n.Agenda-badge-avis {\r\n  background-color: #FF9933;\r\n}\r\n\r\n.Agenda-badge-tasca {\r\n  background-color: #0099CC;\r\n}\r\n\r\n/* Enllaç per obrir/tancar seccions opcionals (p.ex. \"Relacionar amb...\") */\r\n.Agenda-link-toggle {\r\n  background: none;\r\n  border: 1px dashed #bbb;\r\n  border-radius: 4px;\r\n  color: #0078d7;\r\n  cursor: pointer;\r\n  padding: 6px 12px;\r\n  font-size: 13px;\r\n}\r\n\r\n.Agenda-link-toggle:hover {\r\n  background-color: #f4f9ff;\r\n  border-color: #0078d7;\r\n}\r\n\r\n/* Petit toc visual per separar blocs dins del formulari editable */\r\n.Agenda-form .Dashboard-form-row {\r\n  padding-bottom: 4px;\r\n}\r\n\r\n.Agenda-form .checkbox-label {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  font-weight: normal;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
